{
  "bump-small": {
    "offsetX": -0.3,
    "offsetY": -0.25,
    "points": [
      {
        "x": 1.12,
        "y": 0.0
      },
      {
        "x": 0.792,
        "y": 0.424
      },
      {
        "x": 0.0,
        "y": 0.6
      },
      {
        "x": -0.792,
        "y": 0.424
      },
      {
        "x": -1.12,
        "y": 0.0
      },
      {
        "x": -0.792,
        "y": -0.424
      },
      {
        "x": -0.0,
        "y": -0.6
      },
      {
        "x": 0.792,
        "y": -0.424
      }
    ]
  },
  "bump-large": {
    "offsetX": -0.45,
    "offsetY": -0.85,
    "points": [
      {
        "x": 2.55,
        "y": 0.0
      },
      {
        "x": 1.803,
        "y": 0.955
      },
      {
        "x": 0.0,
        "y": 1.35
      },
      {
        "x": -1.803,
        "y": 0.955
      },
      {
        "x": -2.55,
        "y": 0.0
      },
      {
        "x": -1.803,
        "y": -0.955
      },
      {
        "x": -0.0,
        "y": -1.35
      },
      {
        "x": 1.803,
        "y": -0.955
      }
    ]
  },
  "stump": {
    "offsetX": -0.7,
    "offsetY": 0.65,
    "points": [
      {
        "x": 1.14,
        "y": 0.0
      },
      {
        "x": 0.806,
        "y": 0.354
      },
      {
        "x": 0.0,
        "y": 0.5
      },
      {
        "x": -0.806,
        "y": 0.354
      },
      {
        "x": -1.14,
        "y": 0.0
      },
      {
        "x": -0.806,
        "y": -0.354
      },
      {
        "x": -0.0,
        "y": -0.5
      },
      {
        "x": 0.806,
        "y": -0.354
      }
    ]
  },
  "ramp": {
    "offsetX": 0,
    "offsetY": 1.8,
    "points": [
      {
        "x": -4.4,
        "y": -0.65
      },
      {
        "x": 4.4,
        "y": -0.65
      },
      {
        "x": 4.65,
        "y": 0.65
      },
      {
        "x": -4.65,
        "y": 0.65
      }
    ]
  }
}
